import { render, staticRenderFns } from "./accountDetails.vue?vue&type=template&id=ccc98114&scoped=true&"
import script from "./accountDetails.vue?vue&type=script&lang=js&"
export * from "./accountDetails.vue?vue&type=script&lang=js&"
import style0 from "./accountDetails.vue?vue&type=style&index=0&id=ccc98114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc98114",
  null
  
)

export default component.exports